module.exports = __webpack_public_path__ + "f73dd4e6efa4fcce86f5c2519b09b5f7.png";